import { cn } from "../../client/cn";
import logoDark from "../../client/static/ON-Logo-Dark.svg";
import logoLight from "../../client/static/ON-Logo-Light.svg";

interface OptimisticNewsLogoProps {
  alt?: string;
  className?: string;
  lightClassName?: string;
  darkClassName?: string;
  variant?: "auto" | "light" | "dark";
}

export function OptimisticNewsLogo({
  alt = "Optimistic News",
  className = "h-8 w-8",
  lightClassName,
  darkClassName,
  variant = "auto",
}: OptimisticNewsLogoProps) {
  const lightVisibilityClass =
    variant === "auto"
      ? "dark:hidden"
      : variant === "light"
        ? "block"
        : "hidden";
  const darkVisibilityClass =
    variant === "auto"
      ? "hidden dark:block"
      : variant === "dark"
        ? "block"
        : "hidden";

  return (
    <>
      <img
        src={logoLight}
        alt={alt}
        className={cn(className, lightVisibilityClass, lightClassName)}
      />
      <img
        src={logoDark}
        alt={alt}
        className={cn(className, darkVisibilityClass, darkClassName)}
      />
    </>
  );
}
